<template>
    <div class="barra-lateral-esquerdo">
        <figure @click='deslogar' class="figure-image">
            <div v-if="getDeslog" class="backGroundOrangeRed">
                <img src="/imgs/icons/power-white.svg" class="img">
                <figcaption>Deslogado</figcaption>
            </div>
            <div v-else class="backgroundGreen">
                <img src="/imgs/icons/power-white.svg" class="img">
                <figcaption>Logado</figcaption>
            </div>
        </figure>
        <figure @click='messages' class='figure-image messagesChange'>
            <div :class="{'bg-adv': getMessages}">
                <div class="remove-padding">
                    <img  src="/imgs/icons/chat-square-text-white.svg" class='img' alt="">
                        <div class="remove-padding" v-if="(getTotalInQueue > 0 && !getMessages)">
                            <span class="num">{{ getTotalInQueue }}</span>
                        </div>
                </div>
                <figcaption>Atendimento Online</figcaption>
            </div>
        </figure>

		<figure  @click="contacts()" class='figure-image'>
        <div :class="{'bg-adv': getContacts}">
            <img src="/imgs/icons/address-book.svg" class='img'>
            <figcaption>Contatos</figcaption>
        </div>
    </figure>

    <figure  @click="historicol()" class='figure-image'>
        <div :class="{'bg-adv': getShowHistory}">
            <img src="/imgs/icons/arrow-counterclockwise-white.svg" class='img'>
            <figcaption>Histórico</figcaption>
        </div>
    </figure>

		<figure v-if="telefone" class='figure-image'>
            <div v-if="getChannel() != ''" @click="hangup" class="backGroundOrangeRed">
                <img src="/imgs/icons/telephone-forward-white.svg" class='img' alt="">
                <figcaption>Desligar</figcaption>
            </div>
            <div v-else @click="discar">
                <img src="/imgs/icons/telephone-forward-white.svg" class='img' alt="">
                <figcaption>Discar</figcaption>
            </div>
        </figure>

		<figure v-if="telefone" @click="pause" class="figure-image">
			<div v-if='getPause' class="backGroundOrange">
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>{{ time_pause_format }} <br> Pausado</figcaption>
			</div>
			<div v-else>
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>Pausar</figcaption>
			</div>
		</figure>
		<figure v-if="telefone" @click="mute" class='figure-image'>
			<div v-if='getMute' class="backGroundOrange">
				<img src='/imgs/icons/mute-white.svg' class='img' alt="">
				<figcaption>Mudo</figcaption>
			</div>
			<div v-else>
				<img src='/imgs/icons/mute-white.svg' class='img' alt="">
				<figcaption>Mute</figcaption>
			</div>
		</figure>

        <figure @click='agendamento' class='figure-image' style="display:none">
            <div class="">
                <img src="/imgs/icons/calendar-date-white.svg" class='img'>
                <figcaption>Agendamento</figcaption>
            </div>
        </figure>
       	<div hidden>{{hue}}</div>
    </div>

</template>

<script>
import {
	mapGetters,
	mapActions,
	mapMutations
} from 'vuex';

import clientData from '../../store/modules/transduson';

const io = require('socket.io-client');

const isSSL =
	location.hostname === 'localhost'
		? 'http'
		: 'https';

const parsedTelefone =
	process.env.MIX_TELEFONE === 'true';

const connection = parsedTelefone
	? io.connect(`${isSSL}://${location.hostname}:3003/`)
	: {
		on() {},
		emit() {}
	};

export default {
	data() {
		return {
			interval_pause: '',
			time_pause: '',
			time_pause_format: '00:00:00',
			debugDisc: false,
			total_in_queue: '',
			queuesEsquerdo: false,
			queuePause: false,
			telefone: parsedTelefone,
		};
	},

	computed: {
		...mapGetters([
			'getDeslog',
			'getModalPause',
			'getMessages',
			'getOccurrences',
			'getShowHistory',
			'getCnpj',
			'getPause',
			'getMute',
			'getQueues',
			'getExtension',
			'getId',
			'getChannel',
			'getChamada',
			'allClients',
			'getShowSpearhead',
			'getProtocol',
			'getCallTime',
			'getPauseTime',
			'oneClient',
			'getShowBarRight',
			'getTotalMyQueue',
			'getTotalInQueue',
			'getContacts',
			'getCalendar'
		]),

		hue() {
			this.setExtension(user.getExtension());
			this.setQueues(user.getQueue());
			this.setId(user.getId());
		},
	},

	watch: {
		getPauseTime() {
			this.validateTimePause();
		},

		time_pause() {
			this.time_pause_format = moment
				.utc(this.time_pause * 1000)
				.format('HH:mm:ss');
		},

		getDeslog(value) {
			if (!value) {
				if (!this.getMessages) {
					this.setMessage();
				}
			} else {
				if (this.getMessages) {
					this.setMessage();
				}
			}
		}
	},

	created() {
		if (!this.getDeslog && !this.getMessages) {
			this.setMessage();
		}
	},

	methods: {
		...mapActions([
			'selectPause',
			'sendPauseApi',
			'setOccurrences',
			'setShowHistory',
			'setModalPause',
			'setModalSchedule',
			'settModalCall',
			'setMessage',
			'fetchOcurrences',
			'fetchPauses',
			'comeBack',
			'setDeslog',
			'startOrOut',
			'setMute',
			'setExtension',
			'setQueues',
			'setId',
			'getRealTime',
			'sendUnpause',
			'setChannel',
			'fetchClients',
			'fetchProtocol',
			'setShowSpearhead',
			'chooseClient',
			'chooseClientCnpj',
			'clearAllClients',
			'setCallTime',
			'setPauseTime',
			'saveProduct',
			'clearClient',
			'saveClient',
			'setShowBarRight',
			'checkTotalQUeues',
			'totalMyQueue',
			'setContacts',
			'chooseClientPhone'
		]),

		...mapMutations([
			'setClient',
			'delDataConnectLine'
		]),

		cancelarLogoutDoF5() {
			axios.post('/dialer/cancel-page-logout', {
				extension_line: user.getExtension()
			})
			.catch(() => {});
		},

		salvarEstadoLogin(estaLogado) {
			sessionStorage.setItem(
				'operador_logado',
				estaLogado ? 'true' : 'false'
			);
		},

		restaurarEstadoLogin() {
			const estadoSalvo =
				sessionStorage.getItem('operador_logado');

			if (estadoSalvo !== 'true') {
				this.checkLastLoginStatus();
				return;
			}

			if (this.getDeslog) {
				this.setDeslog();
				this.startOrOut();
			}

			setTimeout(() => {
				this.cancelarLogoutDoF5();
			}, 700);
		},

		closeTabLogout() {
			const operadorLogado =
				sessionStorage.getItem('operador_logado');

			if (operadorLogado !== 'true') {
				return;
			}

			if (this.navegacaoInterna) {
				return;
			}

			const form = new FormData();

			form.append('type', 'LOGOUT_PAGE');
			form.append(
				'extension_line',
				user.getExtension()
			);

			const csrfMeta = document.querySelector(
				'meta[name="csrf-token"]'
			);

			if (csrfMeta) {
				form.append(
					'_token',
					csrfMeta.getAttribute('content')
				);
			}

			navigator.sendBeacon(
				'/dialer/logs',
				form
			);
		},

		async checkLastLoginStatus() {
			try {
				const response =
					await axios.get('/dialer/last-log');

				if (response.data.system_logout === true) {
					return;
				}

				const type = response.data.type;

				if (type === 'LOGIN') {
					if (this.getDeslog) {
						this.setDeslog();
						this.startOrOut();
					}

					this.salvarEstadoLogin(true);

					return;
				}

				if (type === 'LOGOUT') {
					if (!this.getDeslog) {
						this.setDeslog();
						this.startOrOut();
					}

					this.salvarEstadoLogin(false);

					return;
				}
			} catch (error) {
			}
		},

		validateTimePause() {
			this.time_pause =
				this.getPauseTime !== 'null'
					? this.getPauseTime
					: 0;

			if (this.getPauseTime !== 'null') {
				this.interval_pause = setInterval(() => {
					this.time_pause++;
				}, 1000);
			} else {
				clearInterval(this.interval_pause);
			}
		},

		historicol() {
			if (
				!this.getDeslog &&
				!this.getShowHistory
			) {
				this.setShowHistory();
				this.fetchOcurrences(this.getCnpj);
			}
		},

		messages() {
			if (
				!this.getDeslog &&
				!this.getMessages
			) {
				this.setMessage();
			}
		},

		discar() {
			this.settModalCall();
		},

		getTime() {
			const d = new Date();

			return d
				.toTimeString()
				.replace(
					/.*(\d{2}:\d{2}:\d{2}).*/,
					'$1'
				);
		},

		pause() {
			this.queuePause = false;

			if (this.getPause === true) {
				connection.emit('QueueUnPause', {
					extension: user.getExtension()
				});

				return;
			}

			if (this.getDeslog === false) {
				this.setModalPause();
				this.fetchPauses();
			}
		},

		agendamento() {
			this.setModalSchedule();
		},

		async deslogar() {
			const data = {
				queues: [user.getQueue()],
				extension: user.getExtension(),
			};

			if (this.getDeslog) {
				if (this.telefone) {
					connection.emit(
						'QueueAdd',
						data
					);
				}

				this.setDeslog();
				this.startOrOut();

				this.salvarEstadoLogin(true);
				this.submitLogin('LOGIN');

				if (!this.getMessages) {
					this.setMessage();
				}

				return;
			}

			if (this.telefone) {
				connection.emit(
					'QueueRemove',
					data
				);
			}

			if (this.getMessages) {
				this.setMessage();
			}

			if (this.getContacts) {
				this.setContacts();
			}

			if (this.getShowHistory) {
				this.setShowHistory();
			}

			this.setDeslog();
			this.startOrOut();

			this.salvarEstadoLogin(false);
			this.submitLogin('LOGOUT');
		},

		mute() {
			if (!this.getChannel()) {
				return;
			}

			this.setMute();

			if (this.getMute === true) {
				localStorage.setItem(
					'mute',
					'true'
				);
			} else {
				localStorage.removeItem('mute');
			}

			const stateMute =
				this.getMute === true
					? 'on'
					: 'off';

			connection.emit('MuteAudio', {
				channel: this.getChannel(),
				extension: user.getExtension(),
				state: stateMute
			});
		},

		async hangup() {
			connection.emit('hangup', {
				channel: this.getChannel()
			});

			await this.setChannel('');

			await clientData.mutations
				.delDataTransduson();
		},

		submitLogin(sub) {
			axios.post('/dialer/logs', {
				type: sub,
				extension_line: user.getExtension()
			})
			.catch(() => {});
		},

		contacts() {
			if (
				!this.getDeslog &&
				!this.getContacts
			) {
				this.setContacts();
			}
		},
	},

	mounted() {
		this.restaurarEstadoLogin();

		window.addEventListener(
			'pagehide',
			this.closeTabLogout
		);

		this.checkTotalQUeues();
		this.totalMyQueue();
	},

	beforeDestroy() {
		window.removeEventListener(
			'pagehide',
			this.closeTabLogout
		);

		if (this.interval_pause) {
			clearInterval(this.interval_pause);
		}
	}
};
</script>

<style scoped>
    .num {
        width: 25px;
        height: 25px;
        text-align: center;
        text-combine-upright: all;
        left: 4em;
        border-radius: 50%;
        line-height: 25px;
        color: white;
        background-color: red;
        top: 5.5em;
        position: absolute;
    }

    .barra-lateral-esquerdo {
        background-color: #CCCCCC;
        width: 100%;
        max-width: 99px;
        text-align: center;
        border-right: solid 1px #1C869A;
         min-height: 100%;
        height: calc(100vh - 4.5em);
			overflow: auto;
    }

	::-webkit-scrollbar {
		width: 0.18rem;
	}

	::-webkit-scrollbar-track {
		background: #f38630;
	}

	::-webkit-scrollbar-thumb {
		background: #1c869a;
	}

    .figure-image {
        margin: 0px;
        display: block;
    }

    .figure-image div {
        margin: 0px;
        padding: 9px 0 9px 0;

    }

    .figure-image figcaption {
        color:white
    }

    .backGroundOrangeRed {
        background-color: orangered;
    }

    .backGroundOrange {
        background-color: #fea33b;
    }

    .bg-adv {
        background: #1c869a;
    }

    .backgroundGreen {
        background: #27ae60;
    }

    .count-msg {
        padding: 0px;
        color: white;
        font-size: 1.5em;
    }

    strong .count-msg {
        font-size: 1.5em;
    }

    .remove-padding {
        padding: 0 !important;
    }
</style>



